export enum IntegrationsRoute {
  INTEGRATIONS_LIST = '/management-panel/integrations',
}
